/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const TemplatePdfEnum = {
    EMPTY: 'EMPTY',
    DUMMY: 'DUMMY'
} as const;
export type TemplatePdfEnum = typeof TemplatePdfEnum[keyof typeof TemplatePdfEnum];

